import QTable from 'quasar/src/components/table/QTable.js';

export function getPreferencesColumnsInAdmin(): QTable['columns'] {
  return [
    {
      name: 'notification_name',
      field: 'notification_name',
      label: 'نام اعلان',
      align: 'left'
    },
    {
      name: 'departments',
      field: 'departments',
      label: 'دپارتمان ها',
      align: 'left'
    }
  ]
}